<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

import { useOnboardingRetentionProgressStore } from '@/stores/onboarding-retention-progress'

definePage({
  path: '/onboarding-retention',
  meta: { layout: false },
})

const router = useRouter()
const progressStore = useOnboardingRetentionProgressStore()

function resolveTargetStep(step: number | undefined) {
  if (!step || step < 1)
    return 1
  if (step > 4)
    return 4
  return step
}

onMounted(async () => {
  try {
    const result = await progressStore.loadFromBackend()
    if (!progressStore.resolvedEsp) {
      router.replace('/onboarding-retention/step0')
      return
    }
    if (result === 'completed') {
      router.replace('/onboarding-retention/step4')
      return
    }
    if (result === 'new') {
      router.replace('/onboarding-retention/step1')
      return
    }
    router.replace(`/onboarding-retention/step${resolveTargetStep(progressStore.progress?.current_step)}`)
  }
  catch {
    if (!progressStore.resolvedEsp) {
      router.replace('/onboarding-retention/step0')
    }
    else {
      router.replace('/onboarding-retention/step1')
    }
  }
})
</script>

<template>
  <div class="min-h-screen bg-[#0b0f17]" />
</template>
